function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm5.71 18.21c-.2.2-.45.29-.71.29s-.51-.1-.71-.29l-5-5a.99.99 0 01-.29-.71V6c0-.55.45-1 1-1s1 .45 1 1v6.09l4.71 4.71c.39.38.39 1.02 0 1.41z"
});

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "32ce5c4812c089034cb1d770a73ee1f4.svg";
export { SvgClock as ReactComponent };